import { Stack, Typography, Button } from "@mui/material";
import DefentSheet from "@/features/HealthScore/components/DefentSheet";
import IconLoader from "@/features/Common/components/IconLoader";

export interface VitalUpdateModalProps {
  isOpen: boolean;
  onClose: () => void;
  icon: string;
  title: string;
  description: string;
  primaryButtonText: string;
  primaryButtonIcon?: string;
  secondaryButtonText: string;
  onPrimaryClick: () => void;
  onSecondaryClick: () => void;
}

export default function VitalUpdateModal({
  isOpen,
  onClose,
  icon,
  title,
  description,
  primaryButtonText,
  primaryButtonIcon,
  secondaryButtonText,
  onPrimaryClick,
  onSecondaryClick,
}: VitalUpdateModalProps) {
  return (
    <DefentSheet
      expanded={isOpen}
      padding={0}
      onExpandedChange={(expanded) => {
        if (!expanded) onClose();
      }}
      onClose={onClose}
    >
      <Stack width="100%" alignItems="center" spacing={2}>
        <IconLoader
          icon={icon}
          sx={{ fontSize: 70, color: "primary.contrastText" }}
        />

        <Typography variant="h3" fontWeight={700} align="center" sx={{ mt: 2 }}>
          {title}
        </Typography>

        <Typography
          fontWeight={500}
          fontSize={16}
          align="center"
          sx={{ color: "neutral.700", mb: 2 }}
        >
          {description}
        </Typography>

        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={onPrimaryClick}
          startIcon={
            primaryButtonIcon ? <IconLoader icon={primaryButtonIcon} /> : null
          }
          sx={{
            py: 1.5,
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 600,
          }}
        >
          {primaryButtonText}
        </Button>

        <Button
          variant="outlined"
          color="primary"
          fullWidth
          onClick={onSecondaryClick}
          sx={{
            py: 1.5,
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 600,
          }}
        >
          {secondaryButtonText}
        </Button>
      </Stack>
    </DefentSheet>
  );
}
